import { Component, OnInit } from '@angular/core';
import { Router, Event, NavigationStart } from '@angular/router';
import { PermissionHelper } from '../shared/permissions/permissions';
import { TranslateService } from '@ngx-translate/core';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';

@Component({
  selector: 'menu',
  templateUrl: './menu.html'
})
export class MenuComponent implements OnInit {
  public loaderEnable:boolean=false;
  constructor(
    public router: Router,
    public _per: PermissionHelper,
    public translate: TranslateService
  ) {

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        if (event.url === "/menu") {
          this.loaderEnable = true;
          this.navToHome();
        }
      }
    });
  }

  public ngOnInit() {
    let location = window.location.href.split('#');
    if (location.length > 1 && location[1] !== "/menu") {
      this.router.navigate([location[1]]);
    } else if (this._per.checkForPermission('EMPLOYEE_ADMIN')) {
      this.router.navigate(['menu/employeesList']);
    } else if (this._per.checkForPermission('ORG_ADMIN')) {
      this.router.navigate(['menu/organizationList']);
    } else if (this._per.checkForPermission('GRADE_ADMIN')) {
      this.router.navigate(['menu/gradeList']);
    } else if (this._per.checkForPermission('MANAGERLEVEL_ADMIN')) {
      this.router.navigate(['menu/mgrLevelList']);
    } else if (this._per.checkForPermission('DESIGNATION_ADMIN')) {
      this.router.navigate(['menu/designationList']);
    } else if (this._per.checkForPermission('CATEGORY_ADMIN')) {
      this.router.navigate(['menu/empTypeList']);
    } else if (this._per.checkForPermission('ROLE_ADMIN')) {
      this.router.navigate(['menu/rolesAndPermission']);
    } else if (this._per.checkForPermission('COB_ADMIN')) {
      this.router.navigate(['menu/cob']);
    } else if (this._per.checkForPermission('ANNOUNCEMENT_ADMIN')) {
      this.router.navigate(['menu/announcementProgram']);
    } else if (this._per.checkForPermission('TENANT_CONFIG')) {
      this.router.navigate(['menu/tenantPreference']);
    } else if (this._per.checkForPermission('TENANT_MANAGEMENT')) {
      this.router.navigate(['menu/tenantManagement']);
    } else if (this._per.checkForPermission('USER_GROUP')) {
      this.router.navigate(['menu/userGroup']);
    } else if (this._per.checkForPermission('passwordPolicy')) {
      this.router.navigate(['menu/passwordPolicy']);
    } else if (this._per.checkForPermission('EMP_BULK_EMPLOYEE_RESIGN')) {
      this.router.navigate(['menu/bulkResignUpload']);
    }
  }

  public navToBusinessRakingUint() {
    window.location.href = "../home/#/admin-component/moderation/businessUnitListModule/businessUnitList";
  }

  public navToStrategyMap() {
    window.location.href = "../home/#/admin-component/strategyModule/strategyListModule/strategyList";
  }

  public navToTaskManagementConfig() {
    window.location.href = "../home/#/admin-component/taskManagementConfigModule/taskManagementConfig";
  }

  public navToHome() {
    window.location.href = "../home/#/hub";
  }
}



// WEBPACK FOOTER //
// ./src/app/menu/menu.ts